module.exports = __webpack_public_path__ + "static/media/Amy Peterson.bad02910.jpg";